import 'firebase/app';

import { $http, Constants } from '@/store/actions/constants';

const url = `${Constants.BaseURL}/employee`;

export const EmployeeActions = {
    Address: ({ commit, state }, payload) => {
        return $http.get(
            `${url}/${payload.id}/address`,
            { ...state.authHeader, params: payload.params },
        );
    },

    Get: ({ commit, state }, id) => {
        return $http.get(`${url}/${id}`, state.authHeader);
    },

    Find: ({ commit, state }, search) => {
        return $http.get(url, { ...state.authHeader, params: search });
    },

    Me: ({ commit, state }) => {
        return $http.get(`${url}/me`, state.authHeader).then(res => {
            if (res.status === 200) {
                commit('SET_ME', res.data);
            }
        });
    },

    Info: ({ commit, state }) => {
        return $http.get(`${url}/info`, state.authHeader);
    },

    AddOrUpdateAddress: ({ commit, state }, payload) => {
        if (payload.addressId) {
            return $http.put(
                `${url}/${payload.userId}/address/${payload.addressId}`,
                payload.data,
                state.authHeader,
            );
        } else {
            return $http.post(
                `${url}/${payload.userId}/address`,
                payload.data,
                state.authHeader,
            );
        }
    },

    Save: ({ commit, state }, payload) => {
        return $http.put(`${url}/${payload.id}`, payload.data, state.authHeader);
    },

    Add: ({ commit, state }, data) => {
        return $http.post(url, data, state.authHeader);
    },

    Delete: ({ commit, state }, id) => {
        return $http.delete(`${url}/${id}`, state.authHeader)
    },

    Timeline: ({ commit, state }, id) => {
        return $http.get(`${url}/${id}/timeline`, state.authHeader).then(res => {
            if (res.status === 200) {
                commit('SET_EMPLOYEE_TIMELINE', res.data);
            }
        });
    },
    AddToTimeline: ({ commit, state }, payload) => {
        return $http.post(`${Constants.BaseURL}/timeline/notes`, payload, state.authHeader);
    },

    Offboarding: ({ commit, state }, payload) => {
        return $http.post(`${url}/offboard/${payload.id}`, payload.data, state.authHeader);
    },
    Profile: ({ commit, state }, id) => {
        return $http.get(`${url}/profile/${id}`, state.authHeader)
    },
    MePersonal: ({ commit, state }, id) => {
        return $http.get(`${url}/me/personal`, state.authHeader)
    },
    UpdateMePersonal: ({ commit, state }, payload) => {
        return $http.put(
            `${url}/${payload.profile_info.user_id}/me/personal`,
            payload,
            state.authHeader,
        );
    },
    Personal: ({ commit, state }, id) => {
        return $http.get(`${url}/${id}/personal`, state.authHeader)
    },
    UpdatePersonal: ({ commit, state }, payload) => {
        return $http.put(
            `${url}/${payload.profile_info.user_id}/personal`,
            payload,
            state.authHeader,
        );
    },
};